<template>
    <v-container fluid class="fill-height px-8">
        <v-row justify="center" align="center">
            <v-col cols="12" md="8">
                <div class="card-box text-center">
                    <v-icon size="72" :color="errorConfig.iconColor">{{ errorConfig.icon }}</v-icon>
                    <h2 class="page-title color-grey-onfly">{{ errorConfig.title }}</h2>
                    <p class="color-grey-onfly">{{ errorConfig.message }}</p>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
const ERROR_CONFIGS = {
    401: {
        icon: 'mdi-link-off',
        iconColor: '#54667a',
        title: 'Link inválido',
        message: 'O link utilizado é inválido ou não existe. Verifique se o link está correto ou entre em contato com o suporte.',
    },
    403: {
        icon: 'mdi-shield-lock-outline',
        iconColor: '#54667a',
        title: 'Sem permissão',
        message: 'Você não possui permissão para realizar esta ação. Entre em contato com o suporte caso acredite que isso seja um erro.',
    },
    410: {
        icon: 'mdi-close-network-outline',
        iconColor: '#54667a',
        title: 'Link expirado ou já utilizado',
        message: 'O link utilizado já foi usado anteriormente ou está expirado. Solicite um novo link para continuar.',
    },
};

const DEFAULT_ERROR_CONFIG = {
    icon: 'mdi-alert-circle-outline',
    iconColor: '#54667a',
    title: 'Acesso não autorizado',
    message: 'Não foi possível validar o seu acesso. Entre em contato com o suporte.',
};

export default {
    name: 'HotelAccessTokenError',
    computed: {
        errorConfig() {
            const code = parseInt(this.$route.query.errorCode);
            return ERROR_CONFIGS[code] || DEFAULT_ERROR_CONFIG;
        },
    },
};
</script>

<style lang="scss" scoped>
.color-grey-onfly {
    color: #54667a !important;
}
.page-title {
    font-weight: bold;
    text-transform: uppercase;
    font-size: 24px;
}
.card-box {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
    border-radius: 16px;
    padding: 48px 32px;
    border: 1px solid lightgrey;
    display: flex;
    flex-direction: column;
    gap: 16px;
    background-color: #ffffff;
}
</style>
